<template>
  <div class="digital-works-page">
    <!-- 如果没有作品 -->
    <el-empty v-if="works.length === 0" description="暂无内容" class="my-empty" />

    <!-- 如果有作品 -->
    <div v-else class="works-container">
      <!-- 循环展示每个作品卡 -->
      <div class="work-card" v-for="(item, i) in works" :key="i">
        <!-- 根据状态显示不同样式 -->
        <div v-if="item.status === 'synthesizing'" class="cover-area-synth">
          <p class="synth-text">视频合成中</p>
          <!-- 合成中状态 -->
          <el-dropdown trigger="click" class="more-dropdown">
            <span class="more-btn">
              <More />
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="openRenameDialog(item)">命名</el-dropdown-item>
                <el-dropdown-item @click="openDeleteDialog(item)">
                  <span style="color: red; font-weight: bold;">删除</span>
                </el-dropdown-item>
              </el-dropdown-menu>

            </template>
          </el-dropdown>
          <el-button v-if="item.modelTag" size="mini" class="model-tag">
            {{ item.modelTag }}
          </el-button>
        </div>

        <div v-else-if="item.status === 'cloning'" class="cover-area-cloning">
          <p class="cloning-text">视频克隆中</p>
          <!-- 克隆中状态 -->
          <el-dropdown trigger="click" class="more-dropdown">
            <span class="more-btn">
              <More />
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="openRenameDialog(item)">命名</el-dropdown-item>
                <el-dropdown-item @click="openDeleteDialog(item)">
                  <span style="color: red; font-weight: bold;">删除</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-button v-if="item.modelTag" size="mini" class="model-tag">
            {{ item.modelTag }}
          </el-button>
        </div>
        <div v-else-if="item.status === 'failed'" class="cover-area-fail">
          <p class="fail-text">视频合成失败</p>
          <!-- 合成失败状态 -->
          <el-dropdown trigger="click" class="more-dropdown">
            <span class="more-btn">
              <More />
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="openRenameDialog(item)">命名</el-dropdown-item>
                <el-dropdown-item @click="openDeleteDialog(item)">
                  <span style="color: red; font-weight: bold;">删除</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-button v-if="item.modelTag" size="mini" class="model-tag">
            {{ item.modelTag }}
          </el-button>
        </div>

        <div v-else class="cover-area">
          <div class="blur-bg" :style="{ backgroundImage: item.cover ? 'url(' + item.cover + ')' : 'none' }"></div>
          <div class="cover-center" @click="openVideo(item)">
            <img v-if="item.cover" :src="item.cover" class="center-cover" alt="作品封面" />
            <div v-else class="cover-placeholder">无封面</div>
            <div class="play-icon">
              <VideoPlay style="width: 36px; height: 36px; color: #fff;" />
            </div>
          </div>
          <div v-if="item.duration" class="duration-tag">
            <i class="el-icon-video-camera"></i>
            {{ item.duration }}
          </div>
          <el-button v-if="item.modelTag" size="mini" class="model-tag">
            {{ item.modelTag }}
          </el-button>
          <!-- 已完成状态 -->
          <el-dropdown trigger="click" class="more-dropdown">
            <span class="more-btn">
              <More />
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="openRenameDialog(item)">命名</el-dropdown-item>
                <el-dropdown-item @click="onDownload(item)">下载</el-dropdown-item>
                <el-dropdown-item @click="openDeleteDialog(item)">
                  <span style="color: red; font-weight: bold;">删除</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>

        <div class="info-area" @click="openVideo(item)">
          <h4 class="work-title">{{ item.title }}</h4>
          <p class="create-time">创建时间: {{ item.createTime }}</p>
        </div>
      </div>
    </div>

    <!-- 视频弹窗 -->
    <el-dialog v-model="dialogVisible" custom-class="video-dialog" :title="activeWork?.title" width="50%"
      :close-on-click-modal="false" @close="handleCloseDialog">
      <div class="dialog-content">
        <div v-if="activeWork && activeWork.isVertical" class="vertical-video-bg"
          :style="{ backgroundImage: 'url(' + activeWork.cover + ')' }"></div>
        <div v-if="activeWork && activeWork.isVertical" class="vertical-video-wrapper">
          <video v-if="activeWork" class="vertical-video" :src="activeWork.videoUrl" autoplay controls />
        </div>
        <div v-else-if="activeWork" class="horizontal-video-wrapper">
          <video class="horizontal-video" :src="activeWork.videoUrl" autoplay controls />
        </div>
      </div>
    </el-dialog>

    <!-- 命名对话框 -->
    <el-dialog title="修改名称" v-model="renameDialogVisible" width="400px" :close-on-click-modal="false">
      <el-input v-model="renameInput" placeholder="请输入新的名称" />
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="renameDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitRename" style="background: #FF5C00;border: none;">提交</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 删除确认对话框 -->
    <el-dialog title="删除确认" v-model="deleteDialogVisible" width="400px" :close-on-click-modal="false">
      <p>确定要删除 <strong>{{ deleteItem?.title }}</strong> 吗？</p>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">取消</el-button>
          <el-button type="danger" @click="confirmDelete">确认删除</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { More, VideoPlay } from "@element-plus/icons-vue";
import axios from "axios";
import config from "@/config.js"; // 引入配置文件
import { ElMessage } from "element-plus";
import { auth } from "@/utils/auth.js"; // 引入封装的 auth.js
export default {
  name: "DigitalWorks",
  components: {
    More,       // 用于“三个点”图标
    VideoPlay,  // 播放图标
  },
  data() {
    return {
      works: [], // 从接口获取的数据
      dialogVisible: false,
      activeWork: null,

      // 命名对话框
      renameDialogVisible: false,
      renameInput: "",
      renameItem: null, // 用来记录正在修改哪个作品

      // 删除确认对话框
      deleteDialogVisible: false,
      deleteItem: null, // 用来记录正在删除哪个作品
    };
  },

  created() {
    this.fetchWorks(); // 页面加载时获取数据
  },

  methods: {
    // 获取作品数据
    async fetchWorks() {
      const user = auth.getStoredUser(); // 从本地存储获取用户信息
      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/person_video_clone_api.php`, {
          action: "get",
          user_id: user.id, // 替换为实际的用户ID
        });

        if (response.data.success) {
          // 对数据进行排序，确保最新的数据在最前面
          const sortedData = response.data.data.sort((a, b) => {
            return new Date(b.create_time) - new Date(a.create_time); // 按创建时间降序排列
          });

          this.works = sortedData.map(item => ({
            id: item.id,
            title: item.title,
            createTime: item.create_time,
            status: item.status === "已完成" ? "done" :
              item.status === "进行中" ? "synthesizing" :
                item.status === "克隆中" ? "cloning" :
                  "failed",
            duration: item.duration || "",
            cover: item.video_clone_url ? `${item.video_clone_url}?x-oss-process=video/snapshot,t_0,m_fast,ar_auto` : "",
            videoUrl: item.video_clone_url || "",
            isVertical: true, // 根据实际情况调整
            modelTag: item.model || "V5模型",
          }));
        } else {
          ElMessage.error("获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        ElMessage.error("获取数据失败，请检查网络");
      }
    },

    // 命名功能
    async submitRename() {
      const user = auth.getStoredUser(); // 从本地存储获取用户信息
      if (!this.renameItem) return;

      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/person_video_clone_api.php`, {
          action: "update",
          user_id: user.id, // 替换为实际的用户ID
          id: this.renameItem.id,
          title: this.renameInput,
        });

        if (response.data.success) {
          this.renameItem.title = this.renameInput;
          this.renameDialogVisible = false;
          ElMessage.success("命名成功！");
        } else {
          ElMessage.error(response.data.error || "命名失败");
        }
      } catch (error) {
        console.error("命名失败:", error);
        ElMessage.error("命名失败，请检查网络");
      }
    },

    // 下载功能
    onDownload(item) {
      const downloadWithXHR = () => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', item.videoUrl, true);
        xhr.responseType = 'blob';

        xhr.onload = () => {
          if (xhr.status === 200) {
            const blob = new Blob([xhr.response]);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${item.title || 'video'}.mp4`; // 根据实际文件类型修改扩展名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
            ElMessage.success('文件下载中...');
          } else {
            // 如果XHR失败则尝试直接打开
            window.open(item.videoUrl, '_blank');
            ElMessage.warning('已打开新窗口，请手动下载');
          }
        };

        xhr.onerror = () => {
          // 网络错误时回退方案
          window.open(item.videoUrl, '_blank');
          ElMessage.warning('下载失败，已打开新窗口');
        };

        xhr.send();
      };

      // 优先尝试强制下载
      try {
        if (!item.videoUrl) {
          throw new Error('无效的下载链接');
        }

        // 如果是跨域资源，推荐使用 fetch + 错误处理
        if (this.isCrossOrigin(item.videoUrl)) {
          fetch(item.videoUrl)
            .then(response => {
              if (!response.ok) throw new Error('网络响应不正常');
              return response.blob();
            })
            .then(blob => {
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.download = item.title || 'video';
              link.click();
              window.URL.revokeObjectURL(url);
              ElMessage.success('下载已开始');
            })
            .catch(error => {
              console.error('Fetch下载失败:', error);
              window.open(item.videoUrl, '_blank');
              ElMessage.warning('已改用新窗口打开');
            });
        } else {
          // 同源资源使用XHR方案
          downloadWithXHR();
        }
      } catch (error) {
        console.error('下载异常:', error);
        // 最终回退方案
        window.open(item.videoUrl, '_blank');
        ElMessage.error('下载失败，已打开新窗口');
      }
    },

    // 辅助方法：判断是否跨域
    isCrossOrigin(url) {
      try {
        const origin = new URL(url).origin;
        return origin !== window.location.origin;
      } catch {
        return true;
      }
    },

    // 删除功能
    async confirmDelete() {
      const user = auth.getStoredUser(); // 从本地存储获取用户信息
      if (!this.deleteItem) return;

      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/person_video_clone_api.php`, {
          action: "delete",
          user_id: user.id, // 替换为实际的用户ID
          id: this.deleteItem.id,
        });

        if (response.data.success) {
          this.works = this.works.filter(work => work.id !== this.deleteItem.id);
          this.deleteDialogVisible = false;
          ElMessage.success("删除成功！");
        } else {
          ElMessage.error(response.data.error || "删除失败");
        }
      } catch (error) {
        console.error("删除失败:", error);
        ElMessage.error("删除失败，请检查网络");
      }
    },

    // 打开命名对话框
    openRenameDialog(item) {
      this.renameItem = item;
      this.renameInput = item.title;
      this.renameDialogVisible = true;
    },

    // 打开删除确认对话框
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deleteDialogVisible = true;
    },

    // 点击卡片
    openVideo(item) {
      if (item.status === "synthesizing" || item.status === "failed") return;
      this.activeWork = item;
      this.dialogVisible = true;
    },

    handleCloseDialog() {
      this.dialogVisible = false;
      this.activeWork = null;
    },
  },
};
</script>
<style scoped>
.digital-works-page {
  padding: 20px;
}

.my-empty {
  margin-top: 100px;
  text-align: center;
}

/* 卡片容器 */
.works-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.work-card {
  width: 320px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  cursor: pointer;
}

/* ===== 合成中 (cover-area-synth) ===== */
.cover-area-synth {
  position: relative;
  width: 100%;
  height: 180px;
  background-color: #f5f6fa;
  /* 背景浅灰 */
  display: flex;
  align-items: center;
  justify-content: center;
}

.synth-text {
  font-size: 18px;
  color: #999;
}

.synth-button {
  position: absolute;
  bottom: 10px;
  left: 10px;
  background-color: #ff8c49;
  border: none;
}

/* ===== 合成失败 (cover-area-fail) ===== */
.cover-area-fail {
  position: relative;
  width: 100%;
  height: 180px;
  background-color: #fff5f5;
  /* 浅红或其他颜色 */
  display: flex;
  align-items: center;
  justify-content: center;
}

.fail-text {
  font-size: 18px;
  color: #ff4d4f;
  /* 红色系 */
}

.fail-button {
  position: absolute;
  bottom: 10px;
  left: 10px;
  background-color: #f56c6c;
  /* Danger色 */
}

/* 普通封面布局 */
.cover-area {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
  background-color: #eee;
}

/* 背景虚化层 */
.blur-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: blur(8px);
  transform: scale(1.2);
  opacity: 0.7;
  z-index: 1;
}

/* 中心封面 */
.cover-center {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.center-cover {
  width: 100px;
  height: auto;
  border-radius: 4px;
  object-fit: cover;
}

.cover-placeholder {
  width: 100px;
  height: 100px;
  background-color: #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
}

/* 播放图标 */
.play-icon {
  position: absolute;
  cursor: pointer;
}

.play-icon svg {
  width: 36px;
  height: 36px;
  color: #fff;
}

.play-icon:hover svg {
  color: #ff5c00;
}

/* 状态标签(合成中、失败等) */
.status-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: #409eff;
  color: #fff;
  font-size: 16px;
  padding: 3px 8px;
  border-radius: 12px;
  z-index: 3;
}

/* 时长标签 */
.duration-tag {
  position: absolute;
  bottom: 10px;
  left: 10px;
  color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 3;
}

/* 模型标签 */
.model-tag {
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: 12px;
  border-radius: 12px;
  padding: 2px 8px;
  background-color: #fff;
  color: #333;
  z-index: 3;
}

/* 三个点更多操作 */
.more-dropdown {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
}

.more-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.more-btn:hover {
  background-color: rgba(0, 0, 0, 0.5);
}

.more-btn>svg {
  width: 20px;
  height: 20px;
}

/* 作品信息区 (标题+时间) */
.info-area {
  padding: 12px;
}

.work-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.create-time {
  margin: 4px 0 0;
  font-size: 12px;
  color: #999;
}

/* 弹窗样式 */
.video-dialog {
  max-width: 600px !important;
  max-height: 80vh;
  position: relative;
  overflow: hidden;
}

/* 弹窗内容区 */
.dialog-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 400px;
  overflow: hidden;
}

/* 竖屏视频的背景 */
.vertical-video-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  filter: blur(8px);
  z-index: 1;
}

/* 视频容器（不受背景虚化影响） */
.vertical-video-wrapper,
.horizontal-video-wrapper {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

/* 视频样式 */
.vertical-video,
.horizontal-video {
  max-height: 100%;
  max-width: 100%;
  border-radius: 8px;
  background-color: #000;
}

/* ===== 克隆中 (cover-area-cloning) ===== */
.cover-area-cloning {
  position: relative;
  width: 100%;
  height: 180px;
  background-color: #f0f9ff;
  /* 浅蓝色背景 */
  display: flex;
  align-items: center;
  justify-content: center;
}

.cloning-text {
  font-size: 18px;
  color: #409eff;
  /* 蓝色文字 */
}
</style>
